import { Outlet, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { commonActions } from "../store/common.slice";

const DEFAULT_THEME = "theme1";

export default function ThemeLayout() {
  // const { listingSlug } = useParams();
  const listingSlug = useSelector(state => state?.checkIn?.listingSlug);
  const location = useLocation();
  const [themeLoaded, setThemeLoaded] = useState(false);
  const dispatch = useDispatch();


  useEffect(() => {
    // Root route "/"
    if (!listingSlug) {
      document.body.classList.add(DEFAULT_THEME);
      setThemeLoaded(true);
      return;
    }


    // Call API via Redux
    const fetchTheme = async () => {
      try {
        const result = await dispatch(commonActions.getTheme({
          listing_slug: listingSlug,
        }));

        const theme = result?.payload?.result?.applicable_css || DEFAULT_THEME;

        localStorage.setItem("theme", theme);
        document.body.classList.add(theme);

        setThemeLoaded(true);
      } catch (err) {
        console.error("Theme API failed", err);

        document.body.classList.remove("theme1", "theme2");
        document.body.classList.add(DEFAULT_THEME);

        setThemeLoaded(true);
      }
    };

    // Do NOT call setThemeLoaded(false) here.
    // Hiding the Outlet while re-fetching causes Common to unmount and remount,
    // which re-fires every API call (currencies, get-host-detail, etc.).
    // The theme CSS class is updated silently on the body without any unmounting.
    fetchTheme();
  }, [listingSlug, dispatch]);



  return (
    <>
      {!themeLoaded && <div className="simpleSpinner" />}
      {themeLoaded && <Outlet />}
    </>
  );
}
